import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from '@/App';
import { UiKitProvider } from '@/components/UiKitProvider';
import { ConfigProvider } from '@/config/ConfigProvider';
import { ThemeProvider } from '@/theme/ThemeProvider';
import { queryClient } from '@/queryClient';
// EAA-1845: side-effect import runs i18next's init() before anything renders.
import '@/i18n';
import '@/styles/fonts.css';
import '@/styles/tokens.css';
import '@/styles/global.css';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <ConfigProvider>
            <QueryClientProvider client={queryClient}>
                {/* EAA-1844: mounts the light/dark theme state above
                    UiKitProvider so the shared kit's colour seam (wired in a
                    parallel change) can read the resolved theme too. */}
                <ThemeProvider>
                    {/* EAA-1804: mounts the shared kit's theme/colour/text seams for
                        the whole tree — see UiKitProvider for what it wires. */}
                    <UiKitProvider>
                        <App />
                    </UiKitProvider>
                </ThemeProvider>
            </QueryClientProvider>
        </ConfigProvider>
    </StrictMode>
);
